import type { ScaleLinear } from 'd3';
import { formatNumber } from '@/utils/helpers/formatters';

export const getTickLength = (yScale: ScaleLinear<number, number>) => {
  const ticks = yScale.ticks().map((tick) => formatNumber(tick, null, true).length);
  const maxTick = Math.max(...ticks);

  return 20 + maxTick * 6;
};
